<template>
  <v-file-input
          ref="fileSelectField"
          v-model="selectFile"
          :label="name"
          :rules="rules"
          outlined
          :accept="accept"
          show-size
          :hint="hint"
          :persistent-hint="Boolean(hint)"
          :hide-details="hideDetails"
          @keypress.enter="onSubmit"
          @click="reset"
          @click:clear="onClear"
  />
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "FileSelectField",
    props: {
      "value": File,
      "name": String,
      "required": Boolean,
      "image": Boolean,
      "topic": Boolean,
      "json": Boolean,
      "csv": Boolean,
      "maxSize": Number,
      "submit": Function,
      "hint": String,
      "hideDetails": Boolean
    },
    computed: {
      selectFile: {
        get () {
          return this.value
        },
        set (value) {
          if (value === null || value === undefined || value instanceof File) {
            this.$emit("input", value)
          }
        }
      },
      rules () {
        return [
          value => {
            if (this.required && !value) {
              return this.error("required", [this.name]);
            }
            if (!!value && this.maxSize && value.size > this.maxSize) {
              return this.error("maxSize", [this.sizeToText(this.maxSize)])
            }
            return true;
          }
        ]
      },
      accept () {
        if (this.image) {
          return "image/jpeg,image/png";
        }
        if (this.json) {
          return "application/json";
        }
        if (this.csv) {
          return "text/csv";
        }
        if (this.topic) {
          return ".jpg,.jpeg,.gif,.png,.tif,.tiff,.svg,.py,.ipynb,.R,.sh,.pdf,.txt,.rtf,.csv,.log,.md,.doc,.docs,.xls,.xlsx,.ppt,.pptx,.pages,.key,.zip,.7z,.tar,.gz,.tgz,.tar.gz,.mp3,.mp4,.mid,.midi,.wav"
        }
        return null;
      }
    },
    methods: {
      onSubmit () {
        if (this.submit) {
          this.submit()
        }
      },
      reset (e) {
        e.target.value = e.target.defaultValue;
      },
      onClear () {
        this.$emit("clearFile");
      }
    }
  }
</script>

<style scoped>

</style>
